if (!customElements.get('multi-location-section')) {
  customElements.define(
    'multi-location-section',
    class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        this.prevBtn = this.querySelector('[data-prev]');
        this.nextBtn = this.querySelector('[data-next]');
        this.progressBar = this.querySelector('[data-progress-bar]');

        this.initCarousel();
        this.updateProgress();
      }

      initCarousel() {
        if (!this.prevBtn || !this.nextBtn || !this.track) return;

        const scrollByCard = (direction) => {
          const card = this.track.querySelector('.also-find-us-card');
          if (!card) return;
          const distance = (card.offsetWidth + 20) * direction;
          this.track.scrollBy({ left: distance, behavior: 'smooth' });
        };

        this.prevBtn.addEventListener('click', () => scrollByCard(-1));
        this.nextBtn.addEventListener('click', () => scrollByCard(1));

        this.initDrag();

        let scrollTimer;
        this.track.addEventListener(
          'scroll',
          () => {
            cancelAnimationFrame(scrollTimer);
            scrollTimer = requestAnimationFrame(() => {
              this.updateArrows();
              this.updateProgress();
            });
          },
          { passive: true }
        );

        new ResizeObserver(() => {
          this.updateArrows();
          this.updateProgress();
        }).observe(this.track);

        this.updateArrows();
      }

      initDrag() {
        let isDown = false;
        let startX = 0;
        let scrollStart = 0;
        let lastX = 0;
        let lastTime = 0;
        let animationId = null;

        this.track.addEventListener('mousedown', (e) => {
          if (animationId) cancelAnimationFrame(animationId);
          isDown = true;
          startX = e.pageX;
          lastX = e.pageX;
          lastTime = Date.now();
          scrollStart = this.track.scrollLeft;
          this.track.style.cursor = 'grabbing';
          this.track.style.scrollSnapType = 'none';
          this.track.style.scrollBehavior = 'auto';
        });

        this.track.addEventListener('mousemove', (e) => {
          if (!isDown) return;
          e.preventDefault();
          lastX = e.pageX;
          lastTime = Date.now();
          this.track.scrollLeft = scrollStart - (e.pageX - startX);
        });

        const stopDrag = (e) => {
          if (!isDown) return;
          isDown = false;
          this.track.style.cursor = '';

          const dt = Date.now() - lastTime;
          const dx = e.pageX - lastX;
          const velocity = dt > 0 ? dx / dt : 0;

          if (Math.abs(velocity) > 0.15) {
            let momentum = velocity * 400;
            const decelerate = () => {
              momentum *= 0.92;
              this.track.scrollLeft -= momentum * 0.016;
              if (Math.abs(momentum) > 0.5) {
                animationId = requestAnimationFrame(decelerate);
              } else {
                this.track.style.scrollSnapType = '';
                this.track.style.scrollBehavior = '';
              }
            };
            animationId = requestAnimationFrame(decelerate);
          } else {
            this.track.style.scrollSnapType = '';
            this.track.style.scrollBehavior = '';
          }
        };

        this.track.addEventListener('mouseup', stopDrag);
        this.track.addEventListener('mouseleave', stopDrag);
      }

      updateArrows() {
        if (!this.track || !this.prevBtn || !this.nextBtn) return;
        const { scrollLeft, scrollWidth, clientWidth } = this.track;
        this.prevBtn.hidden = scrollLeft <= 5;
        this.nextBtn.hidden = scrollLeft >= scrollWidth - clientWidth - 5;
      }

      updateProgress() {
        if (!this.track || !this.progressBar) return;
        const { scrollLeft, scrollWidth, clientWidth } = this.track;
        const maxScroll = scrollWidth - clientWidth;
        const progress = maxScroll > 0 ? (scrollLeft / maxScroll) * 100 : 100;
        const cards = this.track.querySelectorAll('.also-find-us-card').length;
        const minWidth = cards > 0 ? 100 / cards : 100;
        this.progressBar.style.width = Math.max(minWidth, progress) + '%';
      }
    }
  );
}